// src/utils/timeWindow.ts
// Shared helpers for the "last 24 hours" default window used by History pages.

export const DAY_MS = 24 * 60 * 60 * 1000;

/** Epoch ms for "24 hours ago". Call at filter time so the window keeps rolling. */
export const last24hCutoff = (): number => Date.now() - DAY_MS;

/** True when the given timestamp falls inside the rolling 24 hour window. */
export const isWithinLast24h = (
  timestamp: string | number | Date | null | undefined,
  cutoff: number = last24hCutoff()
): boolean => {
  if (!timestamp) return false;
  const ms = timestamp instanceof Date ? timestamp.getTime() : new Date(timestamp).getTime();
  if (Number.isNaN(ms)) return false;
  return ms >= cutoff;
};
